import { View } from 'react-native'
import Animated, {
  Easing,
  Extrapolation,
  interpolate,
  useAnimatedStyle,
  useDerivedValue,
  withTiming,
} from 'react-native-reanimated'

import { colors } from '../../../theme'

function arcClipStyle(animatedHeight: number) {
  'worklet'
  return {
    height: animatedHeight + 1,
    overflow: 'hidden' as const,
  }
}

export function DashboardArcTransition({
  arcDiameter,
  arcLeft,
  arcRadius,
  arcHeight,
  isExpanded,
}: {
  arcDiameter: number
  arcLeft: number
  arcRadius: number
  arcHeight: number
  isExpanded: boolean
}) {
  const progress = useDerivedValue(() =>
    withTiming(isExpanded ? 1 : 0, {
      duration: isExpanded ? 420 : 240,
      easing: isExpanded
        ? Easing.bezier(0.22, 1, 0.36, 1)
        : Easing.out(Easing.cubic),
    }),
  )

  const animatedHeight = useDerivedValue(() =>
    interpolate(progress.value, [0, 1], [0, arcHeight], Extrapolation.CLAMP),
  )

  const containerStyle = useAnimatedStyle(() => ({
    pointerEvents: 'none' as const,
    transform: [{ translateY: -animatedHeight.value }],
  }))

  const clipStyle = useAnimatedStyle(() => arcClipStyle(animatedHeight.value))

  return (
    <Animated.View style={containerStyle}>
      <Animated.View style={clipStyle}>
        <View
          style={{
            position: 'absolute',
            top: 0,
            left: arcLeft,
            width: arcDiameter,
            height: arcDiameter,
            borderRadius: arcRadius,
            backgroundColor: colors.backgroundPrimary,
          }}
        />
      </Animated.View>
    </Animated.View>
  )
}
